import gitSchema from './schema.graphql';
export * from './resolver';

export { gitSchema };
